interface AppIdentifications {
  categories: {
    games: string;
  };
}

export const appIdentifications: AppIdentifications = {
  categories: {
    games: '61d5833caf7963db66fda66d',
  },
};
